import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FunctionalityCode } from 'src/app/core/_enums/functionality.code';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { Role } from 'src/app/core/_models/role';
import { AuthService } from 'src/app/core/_services/auth.service';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  user!: any;
  selectedRole!: Role;
  SiteMapUrl = SiteMapUrl;
  selectedLanguage = 'fr';
  selectedDatabase = '1';
  selectedDatabaseTranslationKey = 'nav_database_FR';

  constructor(
    public router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private dialog: MatDialog
  ) {
    const user = this.authService.userValue;

    if (user && Object.keys(user).length !== 0) {
      this.user = user;

      const json = JSON.parse(localStorage.getItem('userRole') || '{}');
      this.selectedRole = user.roles.find((r: any) => r.profileCode == json.profileCode && r.euId == json.euId && r.perimeterId == json.perimeterId);
      if (this.selectedRole == null || this.selectedRole == undefined) {
        this.selectedRole = user.roles[0];
      }
      this.onProfileChange(this.selectedRole);
    }

    this.authService.roleSubject.subscribe((role) => {
      if (role) {
        this.selectedRole = role;
      }
    });

    const storedRegion = localStorage.getItem('regionId');
    if (storedRegion) {
      this.selectedDatabase = storedRegion;
      this.updateDatabaseLabel(storedRegion);
      this.authService.regionSubject.next(storedRegion);
    }
  }

  ngOnInit() {
    this.selectedLanguage = this.translate.currentLang || 'fr';
  }

  onLanguageChange(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
  }

  updateDatabaseLabel(dbNum: string) {
    switch (dbNum) {
      case '1':
        this.selectedDatabaseTranslationKey = 'nav_database_FR';
        break;
      case '2':
        this.selectedDatabaseTranslationKey = 'nav_database_ES';
        break;
      case '3':
        this.selectedDatabaseTranslationKey = 'nav_database_CA_EN';
        break;
      case '4':
        this.selectedDatabaseTranslationKey = 'nav_database_CA_FR';
        break;
      default:
        this.selectedDatabaseTranslationKey = 'nav_database_FR';
    }
  }

  onDatabaseChange(dbNum: string) {
    const previousDatabase = localStorage.getItem('regionId') || '1';
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_change_region') }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) {
        this.selectedDatabase = previousDatabase;
        return;
      }
      this.updateDatabaseLabel(dbNum);
      this.authService.switchRegion(dbNum);
    });
  }

  onProfileChange(newRole: Role) {
    this.authService.roleSubject.next(newRole);
    localStorage.setItem('userRole', JSON.stringify(newRole));
  }

  onProfileSelected(newRole: Role) {
    const previousRole = this.authService.roleSubject.value;
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_change_profile') }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) {
        this.selectedRole = previousRole;
        return;
      }
      this.onProfileChange(newRole);
      window.location.reload();
    });
  }

  async logout() {
    await this.authService.logout();
  }

  get showLanguageSelector(): boolean {
    return this.authService.accessesValues.includes(FunctionalityCode.TranslationView);
  }

  get showDatabaseSelector(): boolean {
    if (this.authService.accessesValues.length === 0) return false;

    const hasAccess = this.authService.accessesValues.includes(FunctionalityCode.RegionFilteringView);
    if (!hasAccess && localStorage.getItem('regionId')) {
      localStorage.removeItem('regionId');
      this.authService.regionSubject.next(undefined);
    }
    if (hasAccess && !localStorage.getItem('regionId')) {
      localStorage.setItem('regionId', '1');
      this.authService.regionSubject.next('1');
    }
    return hasAccess;
  }

  get showUsefulDocs(): boolean {
    return this.authService.accessesValues.includes(FunctionalityCode.UsefullDocsView);
  }

  get showHelp(): boolean {
    return this.authService.accessesValues.includes(FunctionalityCode.HelpView);
  }

  compareRoles(r1: Role, r2: Role): boolean {
    return r1 && r2 && r1.perimeterId === r2.perimeterId && r1.profileCode === r2.profileCode;
  }
}
